import script from "./ProviderView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProviderView.vue?vue&type=script&lang=ts&setup=true"

import "./ProviderView.vue?vue&type=style&index=0&id=397a6ece&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-397a6ece"]])

export default __exports__